// import { gsap } from "gsap";
    
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// import { SplitText } from "gsap/SplitText";

import Headroom from "headroom.js";

// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event) {

    // extra Scroll Link Klasse
    document.querySelectorAll('.scroll-link').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
    
            // Bestimmen des Ziel-Elements
            const targetElement = document.querySelector(this.getAttribute('href'));
    
            // Offset hinzufügen (z. B. +100px weiter nach unten scrollen)
            const offset = 80;
            const targetPosition = targetElement.offsetTop + offset;
    
            // Scrollen mit einer benutzerdefinierten Position
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'  // Optional: für sanftes Scrollen
            });
        });
    });

    // HEADROOM.JS
    var header = document.querySelector('#wrapper-navbar');
    var headroomOffset = 50;
    var headroom = new Headroom(header, {
        'offset': headroomOffset,
        'tolerance': 5,
    });
    headroom.init();
    if (window.scrollY > headroomOffset) {
        headroom.unpin(); // Sofort ausblenden, falls nicht oben
    }

    //Bei Klick auf Anker-Links header ausblenden, dann wieder aktivieren
    document.querySelectorAll('.dropdown-item[href*="#"]').forEach(link => {
        link.addEventListener('click', () => {
            const linkUrl = new URL(link.href);
            const currentUrl = new URL(window.location.href);
    
            // Code nur ausführen, wenn der Pfad des Links gleich dem aktuellen Pfad ist.
            if (linkUrl.pathname !== currentUrl.pathname) {
                return; // Abbrechen, wenn man sich noch nicht auf der Seite befindet.
            }

            headroom.freeze();
            headroom.unpin();
    
            setTimeout(() => {
                headroom.unfreeze();
            }, 1000);
        });
    });
    
    //wait until images, links, fonts, stylesheets, and js is loaded
    window.addEventListener("load", function(e) {

        var myOffcanvas = document.getElementById('navbarNavOffcanvas');
        var dropdownLinks = document.querySelectorAll('.offcanvas-body .dropdown-menu a');
        var anchorLinks = document.querySelectorAll('.pin-scroll-link');

        if(myOffcanvas) {
            myOffcanvas.addEventListener('show.bs.offcanvas', function () {
                document.body.classList.add("offcanvas-active");

                headroom.freeze();

                //Bei Klick auf Dropdown Link OffCanvas schliessen
                dropdownLinks.forEach(link => {
                    link.addEventListener('click', () => {
                        var bsOffcanvas = understrap.Offcanvas.getInstance(myOffcanvas);
                        bsOffcanvas.hide();
                    });
                });

            });

            myOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
                document.body.classList.remove("offcanvas-active");
                headroom.unfreeze();
            });
        }


        // GSAP START
        // gsap.registerPlugin(ScrollTrigger);
        // gsap.registerPlugin(SplitText);

    
        // Scroll-Back-To-Top
        const scrollTopBtn = document.querySelector('.js-scroll-top');
        if (scrollTopBtn) {
            scrollTopBtn.onclick = () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }

            const progressPath = document.querySelector('.scroll-top path');
            const pathLength = progressPath.getTotalLength();
            progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
            progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
            progressPath.style.strokeDashoffset = pathLength;
            progressPath.getBoundingClientRect();
            progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';
            const updateProgress = function() {
                const scroll = window.scrollY || window.scrollTopBtn || document.documentElement.scrollTopBtn;

                const docHeight = Math.max(
                    document.body.scrollHeight, document.documentElement.scrollHeight,
                    document.body.offsetHeight, document.documentElement.offsetHeight,
                    document.body.clientHeight, document.documentElement.clientHeight
                );

                const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

                const height = docHeight - windowHeight;
                var progress = pathLength - (scroll * pathLength / height);
                progressPath.style.strokeDashoffset = progress;
            }

            updateProgress();
            const offset = 100;

            window.addEventListener('scroll', function(event) {
                updateProgress();

                //Scroll back to top
                const scrollPos = window.scrollY || window.scrollTopBtn || document.getElementsByTagName('html')[0].scrollTopBtn;
                scrollPos > offset ? scrollTopBtn.classList.add('is-active') : scrollTopBtn.classList.remove('is-active');

            }, false);
        }



    }, false);

});
